import { render, staticRenderFns } from "./AssistantsHeaderFilter.vue?vue&type=template&id=6bf16348&scoped=true"
import script from "./AssistantsHeaderFilter.vue?vue&type=script&lang=js"
export * from "./AssistantsHeaderFilter.vue?vue&type=script&lang=js"
import style0 from "./AssistantsHeaderFilter.vue?vue&type=style&index=0&id=6bf16348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf16348",
  null
  
)

export default component.exports